import React, {
  useMemo,
} from 'react'

import Dialog from 'components/Dialog'
import { useConsentConfig } from 'components/ConsentConfigProvider'
import { useDisplayManager } from 'components/DisplayManager'

import TCFDetailsContent from './TCFDetailsContent'

import Styles from './styles.scss'


// TODO: There's a lot of duplication between this and CookieDetails. Right now,
// I'm just trying to gently tease things apart with a minimal diff before I go
// DRY-ing things up.
//
export default function TCFDetails({ details }) {
  const {
    theme,
  } = useConsentConfig()

  const { popActiveUI } = useDisplayManager()

  const innerStyle = useMemo(() => ({
    backgroundColor: theme.background,
  }), [theme])

  return (
    <Dialog
      fixedBody
      handleCancel={ popActiveUI }
      uiType="modal-xl"
    >
      <section
        aria-label="TCF Details"
        className={ Styles.root }
        style={ innerStyle }
      >
        <TCFDetailsContent
          currentStyle={ theme }
          selectedDetails={ details }
        />
      </section>
    </Dialog>
  )
}

TCFDetails.propTypes = {
  details: TCFDetailsContent.propTypes.selectedDetails,
}
